const SELLERS_IMAGE_PATH = "sellers/originals/";
const PRODUCT_IMAGE_PATH = "products/originals/";
const SUBMISSIONS_IMAGE_PATH = "products/submissions/";
const LINE_ITEM_IMAGE_PATH = "lineitem/mockup/";

export { SELLERS_IMAGE_PATH, PRODUCT_IMAGE_PATH, SUBMISSIONS_IMAGE_PATH, LINE_ITEM_IMAGE_PATH };
